// hooks/useCreateRedirect.ts
import { useNavigate } from "react-router-dom";

export const useCreateRedirect = (route: string) => {
	const navigate = useNavigate();
	const handleCreate = () => {
		navigate(route);
	};
	return handleCreate;
};
